<mat-card class="workorder-card" [ngClass]="className">
  <!-- Header Section -->
  <mat-card-header class="work-exception-header header">
    <mat-card-title class="workorder-title">
      Workorder Exceptions
    </mat-card-title>
    <button mat-icon-button matTooltip="Close" class="close-button" (click)="closedialog()">
      <mat-icon class="close-icon" color="warn">close</mat-icon>
    </button>
  </mat-card-header>

  <!-- Loader -->
  <div class="loader-container" *ngIf="loadWorkorder">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>

  <!-- Content Section -->
  <mat-card-content *ngIf="currentWorkorderexceptions != undefined && !loadWorkorder" class="table-wrapper">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8"
      *ngIf="currentWorkorderexceptions.Exceptions.length > 0">

      <!-- Exception Column -->
      <ng-container matColumnDef="Exception">
        <th mat-header-cell *matHeaderCellDef>Exception</th>
        <td mat-cell *matCellDef="let response" matTooltip="{{response.ExceptionDesc}}">
          {{response.ExceptionDesc}}
        </td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="Status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let response" [ngClass]="response.WorkorderStatusCode">
          {{response.WorkorderStatusCode}}
        </td>
      </ng-container>

      <!-- Message Column -->
      <ng-container matColumnDef="Message">
        <th mat-header-cell *matHeaderCellDef>Message</th>
        <td mat-cell *matCellDef="let response" matTooltip="{{response.ExceptionMessage}}">
          {{truncateAtWord(response.ExceptionMessage, 40)}}
        </td>
      </ng-container>

      <!-- Clearable Column -->
      <ng-container matColumnDef="Clearable">
        <th mat-header-cell *matHeaderCellDef>Clearable</th>
        <td mat-cell *matCellDef="let response">
          {{response.ExceptionClearable}}
        </td>
      </ng-container>

      <!-- Clear Checkbox Column -->
      <ng-container matColumnDef="Clear">
        <th mat-header-cell *matHeaderCellDef>Clear</th>
        <td mat-cell *matCellDef="let response">
          <mat-checkbox
            [disabled]="(response.ExceptionClearable === 'Yes' && response.WorkorderStatusCode !== 'cleared') ? false : true"
            [(ngModel)]="response.ClearFlag">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- Table Rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="fixed-header"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="curr-cust"></tr>
    </table>

    <div *ngIf="currentWorkorderexceptions.Exceptions.length === 0" class="no-exceptions-wrapper">
      <span class="no-exceptions">No Exceptions to Show</span>
    </div>
  </mat-card-content>

  <!-- Footer Section -->
  <mat-card-footer class="workorder-footer" *ngIf="currentWorkorderexceptions != undefined && !loadWorkorder">
    <button mat-raised-button color="primary" [disabled]="response.ShowClearException === 1 ? false : true"
      (click)="doClearExceptions()">
      Clear Checked
    </button>
    <button mat-raised-button color="primary" [disabled]="response.ShowClearException === 1 ? false : true"
      (click)="doClearAllExceptions()">
      Clear All Exceptions
    </button>
  </mat-card-footer>
</mat-card>